import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  Table,
  DropdownToggle,
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  Button,
  InputGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
} from "reactstrap";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { getRolesForTables } from "../../../slices/admin/thunk";
import Loading from "../../../Components/Loading";
import FooterPagination from "../../../Components/Pagination/FooterPagination";
import EmployeesTable from "../../../Components/Tables/EmployeesTable/EmployeesTable";
import { DASHBOARD_USER_ROLES } from "../../../constants";
import EditEmployeeModal from "../../../Components/modals/EmployeesModal/EditEmployeeModal";
import NavTabEmployee from "../../../Components/Tabs/NavTabEmployee";
import { getStatusEmployees } from "../../../utils/utils";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import NavTabInfoProfileInfo from "../../../Components/Tabs/NavTabInfoProfileInfo";
import AddEmployeeModal from "../../../Components/modals/EmployeesModal/AddEmployee/AddEmployeeModal";
import AddEmployeesModal from "../../../Components/modals/EmployeesModal/AddEmployee/AddEmployeesModal";
import DropdownActionsTable from "../../../Components/Dropdown/DropdownActionsTable";
import { downloadEmployeesReportByUserId } from "../../../slices/general/thunk";
import { useCurrentUser } from "../../../slices/auth/hooks";

const DashboardEmployeesGA = ({ isLoaded, employeeId }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const isNational = currentUser?.role === DASHBOARD_USER_ROLES.NATIONAL;
  const isAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;

  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("1");
  const [isTerminated, setIsTerminated] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [loading, setLoading] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [openModalAddEmployee, setOpenModalAddEmployee] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const statusEmployees = getStatusEmployees(isTerminated, isPending);
      const response = await dispatch(
        getRolesForTables({
          id: employeeId || id,
          userRole: DASHBOARD_USER_ROLES.GA,
          role: "employees",
          status: statusEmployees,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployees(response.data);
      setTotalEmployees(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      if (debouncedSearchTerm === lastSearchTerm) {
        setSearchDone(true);
      } else {
        setSearchDone(false);
      }
      fetchEmployees();
    }
  }, [
    isTerminated,
    isPending,
    debouncedSearchTerm,
    employeeId,
    id,
    dispatch,
    currentPage,
  ]);

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  const hanldeRefreshTable = () => {
    fetchEmployees();
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleOpenModalAddEmployee = () => {
    setOpenModalAddEmployee(true);
  };


  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      {openModalAddEmployee && (
        <AddEmployeesModal
          open={openModalAddEmployee}
          setOpen={setOpenModalAddEmployee}
          onCreate={() => {
            // Switch tab to pending ones and refresh tablei f current tab is pending.
            if (activeTab === "2") {
              hanldeRefreshTable();
            } else {
              toggleTab("2", "pending");
            }
          }}
        />
      )}

      <>
        <Container fluid>
          <div
            style={{ paddingTop: "3px" }}
            className="col-12 d-flex justify-content-between mt-4 align-items-center "
          >
            <div className="col-4 d-flex justify-content-end align-items-center">
              <SearchBar
                inputRef={inputRef}
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Filter by name or email"
              />
              {(isAdmin || isNational) && (
                <DropdownActionsTable
                  downloadMethod={downloadEmployeesReportByUserId}
                  params={{ dashboardUserId: employeeId || id }}
                />
              )}
            </div>
          </div>

          <Col xl={12}>
            <NavTabEmployee
              loading={loading}
              toggleTab={toggleTab}
              activeTab={activeTab}
            />

            <div className="table-container  position-relative">
              {loading && <Loading />}
              <div className="live-preview">
                <div className="table-responsive ">
                  <EmployeesTable
                    activeTab={activeTab}
                    data={employees}
                    searchDone={searchDone}
                    searchParam={debouncedSearchTerm}
                    onEditClick={handleEditClick}
                    shouldShowImportMessage={false}
                    paginationProps={{
                      currentPage,
                      totalPages,
                      totalItems: totalEmployees,
                      pageSize,
                      onChangePage: handleChangePage,
                    }}
                    openModalAddEmployee={handleOpenModalAddEmployee}
                    isTerminated={isTerminated}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Container>
      </>

      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardEmployeesGA;
